import { Injectable, inject, signal } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

const SUPPORTED_LANGS = ['es', 'en', 'fr', 'pt'] as const;
export type SupportedLang = (typeof SUPPORTED_LANGS)[number];
const STORAGE_KEY = 'mc_lang';
const DEFAULT_LANG: SupportedLang = 'es';

function resolveLang(raw: string): SupportedLang {
  const base = raw.split('-')[0].toLowerCase();
  return (SUPPORTED_LANGS as readonly string[]).includes(base)
    ? (base as SupportedLang)
    : DEFAULT_LANG;
}

@Injectable({ providedIn: 'root' })
export class LanguageService {
  private readonly transloco = inject(TranslocoService);

  readonly supportedLangs = SUPPORTED_LANGS;
  readonly currentLang = signal<SupportedLang>(DEFAULT_LANG);

  init(): void {
    const stored = localStorage.getItem(STORAGE_KEY);
    const lang = stored ? resolveLang(stored) : resolveLang(navigator.language ?? DEFAULT_LANG);
    this.setLang(lang);
  }

  setLang(lang: SupportedLang): void {
    this.currentLang.set(lang);
    localStorage.setItem(STORAGE_KEY, lang);
    this.transloco.setActiveLang(lang);
  }
}
